import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MenuItemOption } from './../menu.model';

@Component({
    selector: 'skl-menu-item-option',
    templateUrl: './menu-item-option.component.html',
    imports: [NgClass]
})
export class MenuItemOptionComponent {
    @Input() public item!: MenuItemOption;

    public constructor() {}

    public getIconCssClass(): string {
        return this.item.isChecked
            ? 'icon-check-square'
            : 'icon-square';
    }

    public getClassNames(): string[] {
        const classNames = [];
        if (this.item.isActive) {
            classNames.push('item-content--active');
        }
        if (this.item.separator) {
            classNames.push('item-content--separator');
        }
        return classNames;
    }
}
